import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFeedbacks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M17.122 3.752A2.25 2.25 0 0 0 15 2.25H9a2.25 2.25 0 0 0-2.123 1.502A3.75 3.75 0 0 0 3.25 7.5V18A3.75 3.75 0 0 0 7 21.75h10A3.75 3.75 0 0 0 20.75 18V7.5a3.75 3.75 0 0 0-3.628-3.748Zm-.001 1.501A2.251 2.251 0 0 1 15 6.75H9a2.25 2.25 0 0 1-2.121-1.497A2.25 2.25 0 0 0 4.749 7.5V18A2.25 2.25 0 0 0 7 20.25h10A2.25 2.25 0 0 0 19.25 18V7.5a2.25 2.25 0 0 0-2.128-2.247ZM15 3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 1 1 0-1.5h6Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.5 10.75a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6Zm3 5a.75.75 0 0 0 0-1.5h-9a.75.75 0 0 0 0 1.5h9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorFeedbacks;
